import {Component, OnInit} from '@angular/core';
import {CommonComponent} from '../common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {Router} from '@angular/router';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import {environment} from '../../../../environments/environment';
import {AccountConfiguration} from '../../../domain/configurations';
import {ConfigurationService} from '../../../services/configuration.service';
import {AccountService} from '../../../services/account.service';
import { marked } from 'marked';
import { Subject, takeUntil } from 'rxjs';
import { ReactiveService } from 'src/app/services/reactive.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent extends CommonComponent implements OnInit {
  configuration: AccountConfiguration;
  programName = environment.productName;
  faqsConfig1 = environment.faqs_config1;
  faqsGuatemala = environment.faqs_guatemala;
  webpage = environment.homeEndpoint;
  cardPrice: number;

  markdownContent: any;

  private readonly destroy$ = new Subject<void>();

  constructor(
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected router: Router,
    private configurationService: ConfigurationService,
    public translate: TranslateService,
    protected dialogService: DialogService,
    protected accountsService: AccountService,
    public reactiveService: ReactiveService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.configuration = configurationService.account;

    configurationService.configReceive.subscribe(
      () => {
        if (!(this.router.url.includes('account') && this.configuration.hasCardPurchase)) {
          this.cardPrice = this.configurationService.account.cardPrice;
        }
      }
    );

    this.translate.onLangChange.subscribe( (event: LangChangeEvent) => {
      this.updateMarkdownContent();
    });

  }

  ngOnInit(): void {
    this.loadingModalOn();

    this.reactiveService.isCompleted$.subscribe((value) => {
      if(value){
        this.updateMarkdownContent();
        this.loadingModalOff()
      }
    });


    if (this.router.url.includes('account') && this.configuration.hasCardPurchase) {
      this.getCardPrice();
    } else {
      if (!this.configurationService.account.cardPrice){
        this.cardPrice = null;
      }else {
        this.cardPrice = this.configurationService.account.cardPrice;
      }
    }
  }

  updateMarkdownContent(): void {

    const FAQS_TEXT = this.configurationService.account.hasCardPurchase
      ? this.configurationService.home.textFaqs
      : this.configurationService.home.textFaqsWithoutCard;

    if (FAQS_TEXT) {
      try {
        const PARSED_TEXT = JSON.parse(FAQS_TEXT);
        let content = PARSED_TEXT[this.translate.currentLang.toString()];

        if (content) {
          content = content.toString()
            .replaceAll('$productName', environment.productName)
            .replaceAll('$cardPrice', `${this.configurationService.account.cardPrice?.toFixed(2) || '0.00'}`)
            .replaceAll('$productHost', environment.homeEndpoint)

            .replaceAll('2600 SW 3rd Ave, Suite 730, Miami, FL 33129', 'P.O. Box 554, Maricopa, Arizona, 85139')
            .replaceAll('2600 SW 3rd Ave, Suite 730, Miami, FL33129', 'P.O. Box 554, Maricopa, Arizona, 85139')
            .replaceAll('1000', '1,000')
            .replaceAll('5000', '5,000')
            .replaceAll(
              'Your funds are FDIC insured up to $250,000 and your account is protected under Mastercard/s Zero Liability Protection.',
              'Your funds are eligible for FDIC insurance up to $250,000 and your account is protected under Mastercard’s zero Liability.'
            )

            .replaceAll('Virtua', 'Virtual')
            .replaceAll('Virtuall', 'Virtual')
            .replaceAll(
              'Tus fondos están asegurados por la FDIC',
              'Sus fondos son elegibles para el seguro de la FDIC'
            )

          this.markdownContent = content;
        } else {
          console.warn(`No se encontró contenido para el idioma: ${this.translate.currentLang}`);
          this.markdownContent = '';
        }
      } catch (error) {
        console.error('Error al parsear el JSON de FAQs:', error);
        this.markdownContent = '';
      }
    } else {
      console.warn('No se encontraron textos de FAQs en la configuración.');
      this.markdownContent = '';
    }

  }

  getCardPrice() {
    this.loadingModalOn();
    this.accountsService.getCardPrice().subscribe(
      (response: any) => {
        this.cardPrice = response.price;
      }, error => {
        this.msgError(error);
      }
    ).add(
      () => {
        this.loadingModalOff();
      }
    );
  }

}
